import React, { useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { getIn } from 'formik';


const { Group, Control, Label } = Form;

export default function FormField({
    field: {...field } = {},
    form: { touched = {}, errors = {} } = {},
    icon,
    value,
    groupProps = {},
    handleChange,
    onChange,
    hintText,
    label,
    isInvalid,
    controlId,
    ...props
}) {
    const showError = !!getIn(touched, field.name) && !!getIn(errors, field.name)
    // const showError = true;
    const fieldRef = useRef(null)
    var isFocused = false
    var isScrolled = false

    // console.log(isError);

    // useEffect(()=>{
    //     console.log(isError);
    // },[isError]);

    const onFocus = () => {
        isScrolled = false
        isFocused = true
    }

    const onBlur = () => {
        isFocused = false
    }

    return (
        <Group controlId={controlId || field.name}>
            {!!label && <Label className='form-label'>{label}</Label>}
            <Control
                ref={fieldRef}
                {...field}
                value={value.field}
                {...props}
                isInvalid={isInvalid}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
            />
            {!!hintText && (
                <Form.Text className='text-muted textarea-hint'>{hintText}</Form.Text>
            )}
            {!!showError && (
                <Control.Feedback type='invalid'>
                    {getIn(errors, field.name)}
                </Control.Feedback>
            )}
        </Group>
    );
}